import { Link } from 'react-router';

interface BreadcrumbProps {
  current: string;
}

export default function Breadcrumb({ current }: BreadcrumbProps) {
  return (
    <div className="dash-breadcrumb">
      <Link to="/">Dashboard</Link>
      <span className="dash-breadcrumb__sep">›</span>
      <span className="dash-breadcrumb__current">{current}</span>
    </div>
  );
}
